import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75 5.5C5.05964 5.5 4.5 6.05964 4.5 6.75V17.25C4.5 17.9404 5.05964 18.5 5.75 18.5H16.25C16.9404 18.5 17.5 17.9404 17.5 17.25V16C17.5 15.5858 17.8358 15.25 18.25 15.25C18.6642 15.25 19 15.5858 19 16V17.25C19 18.7688 17.7688 20 16.25 20H5.75C4.23122 20 3 18.7688 3 17.25V6.75C3 5.23122 4.23122 4 5.75 4H16.25C16.7321 4 17.1874 4.12471 17.5829 4.3442C17.9451 4.54518 18.0758 5.00171 17.8748 5.3639C17.6738 5.72609 17.2173 5.85678 16.8551 5.6558C16.6765 5.55671 16.471 5.5 16.25 5.5H5.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 4.25C15.4142 4.25 15.75 4.58579 15.75 5V7C15.75 7.41421 15.4142 7.75 15 7.75C14.5858 7.75 14.25 7.41421 14.25 7V5C14.25 4.58579 14.5858 4.25 15 4.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 17.25C15.4142 17.25 15.75 17.5858 15.75 18V19C15.75 19.4142 15.4142 19.75 15 19.75C14.5858 19.75 14.25 19.4142 14.25 19V18C14.25 17.5858 14.5858 17.25 15 17.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 4.25C7.16421 4.25 7.5 4.58579 7.5 5V19C7.5 19.4142 7.16421 19.75 6.75 19.75C6.33579 19.75 6 19.4142 6 19V5C6 4.58579 6.33579 4.25 6.75 4.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 8.75C3.25 8.33579 3.58579 8 4 8H6.5C6.91421 8 7.25 8.33579 7.25 8.75C7.25 9.16421 6.91421 9.5 6.5 9.5H4C3.58579 9.5 3.25 9.16421 3.25 8.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H10C10.4142 11.25 10.75 11.5858 10.75 12C10.75 12.4142 10.4142 12.75 10 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 15.25C3.25 14.8358 3.58579 14.5 4 14.5H6.5C6.91421 14.5 7.25 14.8358 7.25 15.25C7.25 15.6642 6.91421 16 6.5 16H4C3.58579 16 3.25 15.6642 3.25 15.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.909 5.68137C19.4841 5.1062 20.4167 5.10621 20.9918 5.68139L22.3186 7.0082C22.8938 7.58335 22.8938 8.51584 22.3187 9.09099L15.6021 15.8076C15.5035 15.9062 15.3793 15.9754 15.2435 16.0073L12.1718 16.7301C11.9189 16.7896 11.6533 16.714 11.4697 16.5303C11.286 16.3467 11.2104 16.0811 11.2699 15.8282L11.9927 12.7565C12.0246 12.6207 12.0938 12.4965 12.1924 12.3979L18.909 5.68137C18.909 5.68137 18.909 5.68136 18.909 5.68137ZM19.9311 6.74203C19.9312 6.74204 19.9311 6.74202 19.9311 6.74203V6.74203ZM19.9504 6.76129L21.2387 8.0496L14.6923 14.596L13.0076 14.9924L13.404 13.3077L19.9504 6.76129Z"
      fill="currentColor"
    />
  </SvgIcon>
));
